import PropTypes from 'prop-types'
import { Row, Col } from 'react-bootstrap'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import {
  SelectedTimeContainer,
  TimeInfo,
  IconWrapper,
  TimeButtonsContainer,
  TimeButton,
  ActionsContainer,
  ActionButton,
  CardBody,
} from './styled'
import SlotModal from './SlotModal'
import theme from '../../constants/theme'
import Clock from '../../assets/svgs/clock'
import Calendar from '../../assets/svgs/calendarSquare'
import { formatDatesForModal } from './utils'

function InterviewTimeSelector({
  isModalOpen,
  setIsModalOpen,
  localAvailableDates,
  selectedDateTime,
  isSubmitting,
  handleSubmit,
  handleDecline,
  handleDateClick,
}) {
  const { t } = useTranslation()

  const openModal = () => setIsModalOpen(true)
  const closeModal = () => setIsModalOpen(false)

  const handleSelectSlot = (date, startTime, endTime, slotData) => {
    handleDateClick(slotData.originalData)
    closeModal()
  }

  const hasAvailableDates =
    Array.isArray(localAvailableDates) && localAvailableDates.length > 0

  return (
    <CardBody>
      {selectedDateTime && (
        <SelectedTimeContainer>
          <TimeInfo>
            <IconWrapper>
              <Calendar width={16} height={16} />
            </IconWrapper>
            {dayjs(selectedDateTime).format('MMM D, YYYY')}
            <IconWrapper>
              <span style={{ marginRight: '0.5rem' }}>-</span>
              <Clock width={16} height={16} />
            </IconWrapper>
            {dayjs(selectedDateTime).format('LT')}
          </TimeInfo>
        </SelectedTimeContainer>
      )}
      <TimeButtonsContainer>
        {selectedDateTime ? (
          <TimeButton onClick={openModal}>{t('calendar.change')}</TimeButton>
        ) : (
          <TimeButton onClick={openModal} disabled={!hasAvailableDates}>
            {hasAvailableDates
              ? t('calendar.selectTimeSlot')
              : t('calendar.noAvailableSlots')}
          </TimeButton>
        )}
      </TimeButtonsContainer>
      <ActionsContainer as={Row}>
        <Col md={6} sm={12} className="p-1">
          <ActionButton
            width="100%"
            backgroundcolor="transparent"
            border={`1px solid ${theme.talentinoRed}`}
            hovercolor={theme.talentinoRed}
            color={theme.talentinoRed}
            onClick={handleDecline}
          >
            {t('calendar.declineInvitation')}
          </ActionButton>
        </Col>
        <Col md={6} sm={12} className="p-1">
          <ActionButton
            width="100%"
            onClick={handleSubmit}
            disabled={!selectedDateTime || isSubmitting}
          >
            {t('general.submit')}
          </ActionButton>
        </Col>
      </ActionsContainer>
      <SlotModal
        isOpen={isModalOpen}
        onClose={closeModal}
        availableDates={formatDatesForModal(localAvailableDates)}
        onSelectSlot={handleSelectSlot}
        initialSelectedDate={
          selectedDateTime
            ? dayjs(selectedDateTime).startOf('day').toDate()
            : null
        }
      />
    </CardBody>
  )
}

InterviewTimeSelector.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  localAvailableDates: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        start: PropTypes.string.isRequired,
        end: PropTypes.string.isRequired,
        eventId: PropTypes.string,
        assignedUser: PropTypes.string,
      }),
    ]),
  ),
  selectedDateTime: PropTypes.string,
  isSubmitting: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  handleDecline: PropTypes.func.isRequired,
  handleDateClick: PropTypes.func.isRequired,
}

InterviewTimeSelector.defaultProps = {
  localAvailableDates: [],
  selectedDateTime: null,
  isSubmitting: false,
}

export default InterviewTimeSelector
